export const USERINFO_UPDATE = 'USERINFO_UPDATE';
export const LOGIN_IN = 'LOGIN_IN';
export const LOGIN_OUT = 'LOGIN_OUT';
export const MSG_NUM_UPDATE = 'MSG_NUM_UPDATE';

export const BADHE_NUM = 'BADHE_NUM'
export const DATE_NUM = 'DATE_NUM'
export const HEADER_PANES = 'HEADER_PANES';
export const HEADER_CUR_PANE = 'HEADER_CUR_PANE';
export const Msg_One_Key = 'Msg_One_Key';

export const ORG_PUT = 'ORG_PUT';
export const LAB_PUT = 'LAB_PUT';
export const GROUP_PUT = 'GROUP_PUT';
export const PILIST_PUT = 'PILIST_PUT';
export const ROLE_PUT = 'ROLE_PUT';
export const TRAIN_PUT = 'TRAIN_PUT';
export const TRAINLABEL_PUT = 'TRAINLABEL_PUT';
export const PISBOX_PUT = 'PISBOX_PUT';

export const PERSONNELTYPE_PUT = 'PERSONNELTYPE_PUT';

export const INSTRUMENT_PUT = 'INSTRUMENT_PUT';
export const TRAINUSER_PUT = 'TRAINUSER_PUT';
export const TRAIN_SPEAKER_PUT = 'TRAIN_SPEAKER_PUT';
export const TRAIN_END_USER_PUT = 'TRAIN_END_USER_PUT';
export const LAB_ROLE_PUT = 'LAB_ROLE_PUT';
export const LAB_USER_PUT = 'LAB_USER_PUT';

export const MEDICINE_BRAND_PUT = 'MEDICINE_BRAND_PUT';
export const MEDICINE_UNIT_PUT = 'MEDICINE_UNIT_PUT';
export const MEDICINE_CLASSIFY_PUT = 'MEDICINE_CLASSIFY_PUT';
export const MEDICINE_ADDRESS_PUT = 'MEDICINE_ADDRESS_PUT';
export const MEDICINE_SUPPLIER_PUT = 'MEDICINE_SUPPLIER_PUT';

export const INSTRUMENT_TYPE_PUT = 'INSTRUMENT_TYPE_PUT';
export const INSTRUMENT_BRAND_PUT = 'INSTRUMENT_BRAND_PUT';
export const INSTRUMENT_ADDRESS_PUT = 'INSTRUMENT_ADDRESS_PUT';

export const UPDATALOADING = 'UPDATALOADING'